import { render } from "./Poll.vue?vue&type=template&id=374bfe43"
import script from "./Poll.vue?vue&type=script&lang=js"
export * from "./Poll.vue?vue&type=script&lang=js"

import "./Poll.vue?vue&type=style&index=0&id=374bfe43&lang=css"

import exportComponent from "/codebuild/output/src173764375/src/givergy_presenter_admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__